import { formatDate } from 'date';
import { formatNumber, MenuItem, Select, type SelectChangeEvent } from 'ui';

export interface SelectableSample {
  id: number;
  date: string;
  total_weight: number | null;
}

const formatDisplay = (sample: SelectableSample) => {
  return `${formatDate(sample.date)} - ${formatNumber(Number(sample.total_weight), { maximumFractionDigits: 2, style: 'kilogram' })}`;
};

export const SampleSelect = ({
  selectedSample,
  handleChangeSample,
  samples,
}: {
  selectedSample: SelectableSample | null;
  handleChangeSample: (event: SelectChangeEvent<string>) => void;
  samples: readonly SelectableSample[];
}) => {
  return (
    <Select
      label="Inspection date"
      value={String(selectedSample?.id)}
      onChange={handleChangeSample}
      id="sample-select"
      data-testid="sample-select"
    >
      {samples?.map((option: SelectableSample) => (
        <MenuItem key={`${option?.date} - ${option?.id}`} value={String(option?.id)}>
          {formatDisplay(option)}
        </MenuItem>
      ))}
    </Select>
  );
};
